var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveToBoards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0618 1.43935C10.7805 1.15804 10.3989 1 10.001 1H2.50017C2.1023 1 1.72073 1.15804 1.43939 1.43935C1.15805 1.72066 1 2.10219 1 2.50003V13.7502C1.00004 13.8816 1.03458 14.0106 1.10015 14.1244C1.16572 14.2382 1.26004 14.3328 1.37365 14.3987C1.48726 14.4646 1.6162 14.4996 1.74755 14.5C1.8789 14.5004 2.00807 14.4664 2.12213 14.4012L5.50652 12.4677C5.73314 12.3383 5.98961 12.2702 6.2506 12.2702C6.51159 12.2702 6.76806 12.3383 6.99468 12.4677L10.3791 14.4012C10.4931 14.4664 10.6223 14.5004 10.7536 14.5C10.885 14.4996 11.0139 14.4646 11.1275 14.3987C11.2412 14.3328 11.3355 14.2382 11.401 14.1244C11.4666 14.0106 11.5012 13.8816 11.5012 13.7502V2.50003C11.5012 2.10219 11.3431 1.72066 11.0618 1.43935Z",
    stroke: "#8F333B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveToBoards);
export default __webpack_public_path__ + "static/media/save-to-boards.3341cf5744e48fef290b598bc160f37c.svg";
export { ForwardRef as ReactComponent };